module.exports = __webpack_public_path__ + "static/media/favicon.397045ec.ico";